var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_36346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42575 1.57422H21.4441C23.838 1.57422 25.7835 3.501 25.7835 5.87187V23.0625H4.08631V5.87187C4.08631 3.501 6.03182 1.57422 8.42575 1.57422Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1673 6.94629H7.70251V14.4672H22.1673V6.94629Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 23.5312V24.2762C10.6533 25.4616 9.68057 26.425 8.48361 26.425H7.92671C6.72975 26.425 5.75699 25.4616 5.75699 24.2762V23.5312",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1164 23.5312V24.2762C24.1164 25.4616 23.1437 26.425 21.9467 26.425H21.3898C20.1929 26.425 19.2201 25.4616 19.2201 24.2762V23.5312",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54339 17.6904H10.6389C11.438 17.6904 12.0853 18.3315 12.0853 19.123V19.2054C12.0853 19.5563 11.7997 19.8393 11.4453 19.8393H7.54339C6.96842 19.8393 6.50193 19.3773 6.50193 18.8078V18.7254C6.50193 18.156 6.96842 17.694 7.54339 17.694V17.6904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3264 19.8389H18.4245C18.0702 19.8389 17.7845 19.5559 17.7845 19.205V19.1226C17.7845 18.3311 18.4318 17.69 19.231 17.69H22.3264C22.9014 17.69 23.3679 18.152 23.3679 18.7215V18.8038C23.3679 19.3733 22.9014 19.8353 22.3264 19.8353V19.8389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0287 14.4668L19.061 10.5811",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0945 14.4668L13.1268 10.5811",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00313 11.5839L1.08486 10.1514",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 11.5839L28.9151 10.1514",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_36346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBus);
export default __webpack_public_path__ + "static/media/icBus.5aeee6ca9273645f33f377e44150851a.svg";
export { ForwardRef as ReactComponent };